import { render, staticRenderFns } from "./volver.vue?vue&type=template&id=02cefa8e&scoped=true"
import script from "./volver.vue?vue&type=script&lang=js"
export * from "./volver.vue?vue&type=script&lang=js"
import style0 from "./volver.vue?vue&type=style&index=0&id=02cefa8e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cefa8e",
  null
  
)

export default component.exports